import { Button } from "react-bootstrap";

interface NoDataProps {
    onTap?: () => void;
}

export default function NoData(props: NoDataProps) {
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>No data yet!</h2>
        <p>There's no data available yet, try to add some data from green add button below</p>
        <img
            src="https://i.giphy.com/qQdL532ZANbjy.webp"
            alt="No data GIF"
            style={{ width: '300px', height: '300px', margin: '20px' }}
        />
        {
            props.onTap !== undefined && props.onTap !== null &&
            <Button variant="outline-dark" style={{ borderRadius: 90 }} onClick={props.onTap}>✍ Add</Button>
        }
    </div>;
}